import { createApiHooks } from '@apis/next/common';
import { Company, CompanyDetails, DashboardPatchCompany } from '@models/next/Company';
import { AdminUser } from '@models/next/User';

export const dashboardCompanyApis = createApiHooks('/dashboard/company', [
  {
    method: 'get',
    path: '/:id',
    response: Company,
  },
  {
    method: 'get',
    path: '/:id/staff',
    response: AdminUser.array(),
  },
  {
    method: 'get',
    path: '/:id/detail',
    response: CompanyDetails,
  },
  {
    method: 'patch',
    path: '/:id/detail',
    parameters: [
      {
        type: 'Body',
        name: 'body',
        schema: DashboardPatchCompany,
      },
    ],
    response: CompanyDetails,
  },
]);

export const companyApis = createApiHooks('/company', [
  {
    method: 'get',
    path: '/',
    response: CompanyDetails,
  },
]);
